export default "__VITE_ASSET__6d5bf1e6__"